import { i as implementation$1 } from './implementation.js';

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

export { functionBind as f };
